<template>
  <router-view/>
</template>

<style lang="scss">
@font-face {
    font-family: 'Modern Era';
    src: url('@/assets/fonts/ModernEra-Regular.woff2') format('woff2'),
        url('@/assets/fonts/ModernEra-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Modern Era';
    src: url('@/assets/fonts/ModernEra-Bold.woff2') format('woff2'),
        url('@/assets/fonts/ModernEra-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Sharp Grotesk';
    src: url('@/assets/fonts/SharpGroteskBold-15.woff2') format('woff2'),
        url('@/assets/fonts/SharpGroteskBold-15.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Sharp Grotesk';
    src: url('@/assets/fonts/SharpGroteskBoldItl-15.woff2') format('woff2'),
        url('@/assets/fonts/SharpGroteskBoldItl-15.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}


#app {
  font-family: 'Sharp Grotesk', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
html, body {
  padding:0;
  margin:0;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--dark-blue);
  }
  &::-webkit-scrollbar-thumb {
    background:var(--blueGradient);
  }
}
:root {  
    --dark-blue:#0B182B;
    --grey:#6D7B7C;
    --black:#000;
    --white:#fff;
    --blueGradient: linear-gradient(180deg, #0479E8 0%, #005AB0 100%);
    --greyGradient:linear-gradient(180deg, #AEAEAE 0%, #6D7B7C 100%);
    --navy:#0A172A;
    --red:#C60C03;  
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
